// extracted by css-extract-rspack-plugin
export default {"pageNavigation":"src-modules-desktop-components-ProductTourModal-PageNavigation-PageNavigation-module__pageNavigation-HR5VmE","pages":"src-modules-desktop-components-ProductTourModal-PageNavigation-PageNavigation-module__pages-dhXxGh","page":"src-modules-desktop-components-ProductTourModal-PageNavigation-PageNavigation-module__page-AzB6Wu","active":"src-modules-desktop-components-ProductTourModal-PageNavigation-PageNavigation-module__active-AD4cpA","showNavigation":"src-modules-desktop-components-ProductTourModal-PageNavigation-PageNavigation-module__showNavigation-LyZDQY"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"pageNavigation\":\"src-modules-desktop-components-ProductTourModal-PageNavigation-PageNavigation-module__pageNavigation-HR5VmE\",\"pages\":\"src-modules-desktop-components-ProductTourModal-PageNavigation-PageNavigation-module__pages-dhXxGh\",\"page\":\"src-modules-desktop-components-ProductTourModal-PageNavigation-PageNavigation-module__page-AzB6Wu\",\"active\":\"src-modules-desktop-components-ProductTourModal-PageNavigation-PageNavigation-module__active-AD4cpA\",\"showNavigation\":\"src-modules-desktop-components-ProductTourModal-PageNavigation-PageNavigation-module__showNavigation-LyZDQY\"}";
        // 1793874325097
        var cssReload = require("../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  